export const searchOverlay = 1090;
export const overSearchOverlay = searchOverlay + 1;
export const globalOverlay = 1100;
export const overGlobalOverlay = globalOverlay + 1;
export const modal = 1050;
